import { NavLink } from 'react-router-dom';
import './Header.css';
export default function Logo() {
  return (
    <NavLink to='/swapandtop/'>
      <svg
        className='logo'
        id='Layer_2'
        data-name='Layer 2'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 261.42 55'>
        <g id='Layer_2-2' data-name='Layer 2' fill='#fff'>
          <g className='cls-2'>
            <path
              className='cls-1'
              d='M70.57,32.28h5.7c-.13,1.57,.77,2.62,2.62,2.62,1.6,0,2.69-.7,2.69-2.08,0-3.62-9.6-2.75-9.66-9.41-.06-4.54,3.65-7.2,8.74-7.2s8.26,2.56,7.84,6.72h-5.82c.19-1.41-.67-2.4-2.3-2.4-1.54,0-2.59,.8-2.59,2.08,0,3.46,9.7,3.1,9.7,9.73,0,3.97-3.33,6.88-8.74,6.88-5.02,0-8.7-2.37-8.16-6.94Z'
            />
            <path
              className='cls-1'
              d='M96.49,21.15l.26,12.77,5.28-12.77h5.79l.8,12.77,4.74-12.77h5.15l-8,17.85h-6.05l-.77-11.58-4.96,11.58h-6.02l-1.7-17.85h5.47Z'
            />
            <path
              className='cls-1'
              d='M127.4,20.89c2.66,0,4.32,1.22,5.02,2.78l.45-2.53h5.47l-3.17,17.85h-5.47l.48-2.53c-1.28,1.57-3.39,2.78-6.05,2.78-4.35,0-7.2-3.58-6.21-9.21,.99-5.63,5.09-9.15,9.47-9.15Zm.77,4.77c-2.05,0-4.19,1.54-4.67,4.38-.51,2.85,1.06,4.45,3.1,4.45s4.19-1.57,4.7-4.42c.51-2.85-1.06-4.42-3.14-4.42Z'
            />
            <path
              className='cls-1'
              d='M153.32,20.89c4.38,0,7.23,3.52,6.24,9.15-.99,5.63-5.09,9.21-9.47,9.21-2.62,0-4.29-1.25-5.02-2.75l-1.95,11.01h-5.47l4.64-26.37h5.47l-.45,2.53c1.28-1.57,3.39-2.78,6.02-2.78Zm-2.43,4.77c-2.08,0-4.19,1.57-4.7,4.42-.51,2.85,1.06,4.42,3.1,4.42s4.22-1.6,4.74-4.45c.48-2.85-1.09-4.38-3.14-4.38Z'
            />
            <path
              className='cls-1'
              d='M182.18,21.47c0-.83-.64-1.28-1.47-1.28-1.15,0-2.08,.83-2.08,1.98,0,.8,.42,1.63,1.28,2.72l4.51,5.34c.19-.29,.38-.58,.58-.9l1.54-2.02h5.5l-2.02,2.78c-.86,1.34-1.73,2.56-2.66,3.62l4.48,5.28h-6.37l-1.73-2.02c-2.3,1.57-4.9,2.37-7.84,2.37-4.67,0-7.58-2.21-7.58-5.76s2.53-6.18,6.05-7.68c-.7-1.09-.99-2.02-.99-3.01,0-4,3.36-6.66,8-6.66,4,0,5.98,2.08,5.98,4.64,0,.32-.03,.61-.1,.96h-5.12c.03-.13,.03-.26,.03-.38Zm-1.22,12.29l-4.13-4.83c-1.79,.83-2.91,2.14-2.91,3.65,0,1.34,1.09,2.37,3.07,2.37,1.47,0,2.78-.42,3.97-1.18Z'
            />
            <path
              className='cls-1'
              d='M221.64,16.54l-.74,4.32h-5.98l-3.2,18.14h-5.47l3.2-18.14h-5.95l.77-4.32h17.37Z'
            />
            <path
              className='cls-1'
              d='M220.74,31.77c0-6.18,4.7-10.88,11.04-10.88,4.67,0,7.9,3.01,7.9,7.52,0,6.24-4.83,10.85-11.1,10.85-4.67,0-7.84-2.98-7.84-7.49Zm13.28-2.85c0-2.24-1.38-3.33-3.04-3.33-2.85,0-4.61,2.85-4.61,5.7,0,2.18,1.28,3.26,2.98,3.26,2.82,0,4.67-2.85,4.67-5.63Z'
            />
            <path
              className='cls-1'
              d='M254.98,20.89c4.38,0,7.23,3.52,6.24,9.15-.99,5.63-5.09,9.21-9.47,9.21-2.62,0-4.29-1.25-5.02-2.75l-1.95,11.01h-5.47l4.64-26.37h5.47l-.45,2.53c1.28-1.57,3.39-2.78,6.02-2.78Zm-2.43,4.77c-2.08,0-4.19,1.57-4.7,4.42-.51,2.85,1.06,4.42,3.1,4.42s4.22-1.6,4.74-4.45c.48-2.85-1.09-4.38-3.14-4.38Z'
            />
            <path
              id='Path_1-2'
              data-name='Path 1-2'
              className='cls-1'
              d='M53.03,15.26l-20.1,5.43-.59,1.14-4.22,1.14-1.5,.4-4.11,1.11-1.1-.69-6.5,1.76c-1.7,.47-3.46-.51-3.95-2.21l-.91-3.27L49.14,9.52c-.06-.07-.13-.14-.19-.22L10,19.83l-.36-1.29c-.14-.52,.16-1.05,.68-1.2,0,0,.01,0,.02,0L47.07,7.4C41.78,2.55,34.84-.09,27.67,0,12.22,.17-.24,12.76,0,27.94c.05,3.04,.6,6.04,1.65,8.9,1.9-1.5,3.64-3.03,4.53-3.83,2.16-1.96,7.12-3.27,13.3-1.14,1.58,.53,3.24,.8,4.92,.81,.57,.01,1.13-.07,1.67-.24l4.92-1.45c.96-.29,1.98,.25,2.28,1.21h0c.03,.1,.05,.2,.06,.3,4.67-1.28,17.19-4.9,17.94-4.98,.47-.05,1,.57,.2,1.15-3.73,2.7-20.99,15.35-23.04,15.8-.34,.06-.69,.09-1.03,.07-4.12-.05-16.46-.65-16.46-.65-.08,0-.15,.02-.21,.07-.34,.29-1.6,1.39-2.95,2.57,5.31,5.44,12.6,8.49,20.2,8.47,15.31,.13,27.83-12.18,27.97-27.49,0-4.25-.99-8.45-2.92-12.24h0Z'
            />
          </g>
        </g>
      </svg>
    </NavLink>
  );
}
